import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { HomePage } from "./pages/HomePage";
import { MissionPage } from "./pages/MissionPage";
import { ExplanationPage } from "./pages/ExplanationPage";
import { ImprintPage } from "./pages/ImprintPage";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/mission" element={<MissionPage />} />
          <Route path="/explanation" element={<ExplanationPage />} />
          <Route path="/imprint" element={<ImprintPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
